module.exports = __webpack_public_path__ + "static/media/financial_models_ad.37252fe8.png";